module.exports = __webpack_public_path__ + "img/cbr-save.28baab84.svg";